import React, { useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { IconButton, Switch } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "../../theme/theme"
import FilledButtonM from "../button/FilledButtonM"
import { ListGroupM } from "../list/ListGroupM"
import { ListItemM } from "../list/ListItemM"
import { ModalM } from "../modal/ModalM"
import TextM from "../text/TextM"

export const SelectRangeModalM = (props) => {
    const {
        modalVisible,
        setModalVisible,
        title,
        options,
        itemHeight = 70,
        selectedValues = [],
        onFinishSelecting = () => {},
        withClipBoard,
        onRangeSelect,
    } = props

    const [rangeStart, setRangeStart] = useState(null)
    const [rangeEnd, setRangeEnd] = useState(null)
    const [tempSelectedValues, setTempSelectedValues] = useState([])
    const [selectAllActive, setSelectAllActive] = useState(false)

    useEffect(() => {
        if (modalVisible) {
            setRangeStart(null)
            setRangeEnd(null)
            setTempSelectedValues([...selectedValues])

            const allValues = options.map((opt) => opt.value)
            const allSelected =
                allValues.length === selectedValues.length &&
                allValues.every((value) => selectedValues.includes(value))
            setSelectAllActive(allSelected)
        }
    }, [modalVisible, selectedValues, options])

    const handleItemPress = (item) => {
        if (selectAllActive) {
            setSelectAllActive(false)
        }

        const value = item.value

        if (rangeStart === null) {
            setRangeStart(value)
            setTempSelectedValues([value])
            return
        }

        if (rangeEnd === null) {
            setRangeEnd(value)

            const allValues = options.map((opt) => opt.value)
            const startIndex = allValues.indexOf(rangeStart)
            const endIndex = allValues.indexOf(value)

            if (startIndex === -1 || endIndex === -1) return

            const minIndex = Math.min(startIndex, endIndex)
            const maxIndex = Math.max(startIndex, endIndex)

            const rangeValues = options
                .slice(minIndex, maxIndex + 1)
                .map((opt) => opt.value)

            setTempSelectedValues(rangeValues)
        } else {
            setRangeStart(value)
            setRangeEnd(null)
            setTempSelectedValues([value])
        }
    }

    const applySelection = () => {
        onRangeSelect(tempSelectedValues)
        setModalVisible(false)
        onFinishSelecting()
    }

    const toggleSelectAll = () => {
        const newSelectAllState = !selectAllActive
        setSelectAllActive(newSelectAllState)

        if (newSelectAllState) {
            const allValues = options.map((opt) => opt.value)
            setTempSelectedValues(allValues)
            setRangeStart(allValues[0])
            setRangeEnd(allValues[allValues.length - 1])
        } else {
            clearSelection()
        }
    }

    const clearSelection = () => {
        setTempSelectedValues([])
        setRangeStart(null)
        setRangeEnd(null)
        setSelectAllActive(false)
    }

    return (
        <ModalM
            style={{
                justifyContent: "center",
                alignItems: "center",
                height: "95%",
                width: "100%",
            }}
            visible={modalVisible}
            onDismiss={() => {
                setModalVisible(false)
                onFinishSelecting()
            }}
        >
            <IconButton
                icon="times"
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                style={{
                    alignSelf: "flex-start",
                }}
                size={32}
                onPress={() => {
                    setModalVisible(false)
                    onFinishSelecting()
                }}
            />

            <View
                style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    width: "100%",
                    paddingHorizontal: 20,
                }}
            >
                <TextM
                    fontSize={22}
                    fontWeight="Bold"
                    color={theme.colors.primary}
                    style={{
                        flex: 1,
                    }}
                    wrap
                >
                    {title}
                </TextM>
            </View>

            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    width: "100%",
                    paddingHorizontal: 20,
                    marginTop: 5,
                    marginBottom: 10,
                    alignItems: "center",
                    alignSelf: "flex-end",
                }}
            >
                <TouchableOpacity
                    onPress={toggleSelectAll}
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: theme.colors.white,
                        borderRadius: 8,
                    }}
                >
                    <Switch
                        value={selectAllActive}
                        onValueChange={toggleSelectAll}
                        color={theme.colors.primary}
                        style={{
                            marginRight: 8,
                            transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }],
                        }}
                    />
                    <TextM
                        fontSize={14}
                        fontWeight="Medium"
                        color={theme.colors.primary}
                    >
                        Tout sélectionner
                    </TextM>
                </TouchableOpacity>
            </View>


            <View
                style={{
                    flex: 1,
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    marginTop: 5,
                    width: "100%",
                    height: "100%",
                    backgroundColor: theme.colors.white,
                    paddingHorizontal: 20,
                }}
            >
                <ListGroupM
                    options={options}
                    style={{ marginBottom: 30 }}
                    itemHeight={itemHeight}
                    renderItem={(item) => {
                        const isSelected = tempSelectedValues.includes(
                            item.item.value
                        )
                        const isRangeBoundary =
                            item.item.value === rangeStart ||
                            item.item.value === rangeEnd

                        return (
                            <ListItemM
                                onPress={() => handleItemPress(item.item)}
                                itemHeight={itemHeight}
                                selected={isSelected}
                                option={item.item}
                                withClipBoard={withClipBoard}
                                style={{
                                    backgroundColor:
                                        isRangeBoundary && !selectAllActive
                                            ? theme.colors.primaryLightest
                                            : undefined,
                                    borderLeftWidth:
                                        isRangeBoundary && !selectAllActive
                                            ? 4
                                            : 0,
                                    borderLeftColor:
                                        isRangeBoundary && !selectAllActive
                                            ? theme.colors.primary
                                            : undefined,
                                }}
                                rightComponent={
                                    isRangeBoundary && !selectAllActive
                                        ? () => (
                                              <FontAwesome5
                                                  name={
                                                      item.item.value ===
                                                      rangeStart
                                                          ? "play"
                                                          : "stop"
                                                  }
                                                  size={14}
                                                  color={theme.colors.primary}
                                                  style={{ marginRight: 10 }}
                                              />
                                          )
                                        : null
                                }
                            />
                        )
                    }}
                />
            </View>

            <FilledButtonM
                style={{
                    marginRight: 20,
                    marginLeft: 20,
                    marginBottom: 70,
                    marginTop: 10,
                    width: "90%",
                }}
                onPress={applySelection}
                label={`Appliquer (${tempSelectedValues.length} créneaux)`}
            />
        </ModalM>
    )
}

export default SelectRangeModalM
